module.exports = __webpack_public_path__ + "img/block.aee20f45.png";